// Plugin to inject custom CSS for sidebar fixes
const SidebarFixPlugin = {
  install(Vue) {
    // Create a style element
    const styleEl = document.createElement("style");
    styleEl.innerHTML = `
      /* Sidebar fixes for alignment */
      .v-list-group .v-list-group__header {
        display: flex !important;
        align-items: center !important;
        min-height: 48px !important;
        padding-left: 14px !important;
      }
      
      .v-list-group .v-list-group__header .v-list-item__icon {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin-right: 12px !important;
        margin-left: 0 !important;
      }
      
      .v-list-group .v-list-group__header .v-list-item__content {
        display: flex !important;
        align-items: center !important;
        min-height: 48px !important;
      }
      
      /* Fix icon alignment in the sidebar */
      #drawer .v-list-item__icon {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
      
      /* Remove the default prepend icon slot to fix alignment */
      .v-list-group .v-list-item__icon.v-list-group__header__prepend-icon {
        display: none !important;
      }
    `;

    // Add the style element to the document head
    document.head.appendChild(styleEl);
  },
};

export default SidebarFixPlugin;
